import { render, staticRenderFns } from "./PostAiGenerativeJob.vue?vue&type=template&id=559058ac&scoped=true&"
import script from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts&"
export * from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts&"
import style0 from "./PostAiGenerativeJob.vue?vue&type=style&index=0&id=559058ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559058ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VRow,VTextarea,VTooltip})
